import React, { useState } from "react";

const getInitialFormData = (preSelectedService) => ({
  name: "",
  email: "",
  message: "",
  category: preSelectedService || "Rodinné focení",
});

const ContactForm = ({ preSelectedService }) => {
  const [formData, setFormData] = useState(() =>
    getInitialFormData(preSelectedService),
  );
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      const res = await fetch(
        "https://api.headlessforms.cloud/api/v1/form/jX1JZYSVgI",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(formData),
        },
      );

      const data = await res.json();

      if (!res.ok) throw new Error(data?.error || "Request failed");

      setStatus("success");
      setFormData(getInitialFormData(preSelectedService));
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <div className="w-full">
      {status === "success" && (
        <p className="mb-6 p-3 bg-green-600 text-white">
          Děkuji, Vaše zpráva byla odeslána. Brzy se ozvu zpět.
        </p>
      )}
      {status === "error" && (
        <p className="mb-6 p-3 bg-red-600 text-white">
          Omlouvám se, zprávu se nepodařilo odeslat. Zkuste to prosím znovu,
          nebo mi napište přímo na email.
        </p>
      )}

      <form onSubmit={handleSubmit}>
        <div className="mb-8">
          <label htmlFor="categorySelect" className="block font-medium mb-1">
            Vyberte o jakou službu máte zájem
          </label>
          <select
            id="categorySelect"
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="w-full p-2 border"
          >
            <option value="Rodinné focení">Rodinné focení</option>
            <option value="Párové focení">Párové focení</option>
            <option value="Těhotenské focení">Těhotenské focení</option>
            <option value="Svatební focení">Svatební focení</option>
            <option value="Chci se jen informovat">
              Chci se jen informovat
            </option>
          </select>
        </div>

        <div className="mb-8">
          <label htmlFor="name" className="block font-medium mb-1">
            Vaše jméno
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Vaše jméno"
            className="w-full p-2 border"
            required
          />
        </div>

        <div className="mb-8">
          <label htmlFor="email" className="block font-medium mb-1">
            Emailová adresa
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="email@seznam.cz"
            className="w-full p-2 border"
            required
          />
        </div>

        <div className="mb-8">
          <label htmlFor="message" className="block font-medium mb-1">
            Prostor pro Vaší zprávu
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows="4"
            placeholder="Mám zájem o rodinné focení"
            className="w-full p-2 border"
            required
          ></textarea>
        </div>

        <button
          type="submit"
          className="btn-secondary"
          disabled={status === "sending"}
        >
          {status === "sending" ? "Odesílám…" : "Odeslat"}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
